import * as React from "react";
import {Button, Card, Form, Grid, Input, Image, TextArea, Dropdown} from "semantic-ui-react";
import coreState, {ICoreState} from "../../common/CoreState";
import {UtilityManager} from "../../../core/utility/UtilityManager";
import {IReadReportResponse} from "../../../core/api/report/response/IReadReportResponse";
import {StateManager} from "../../../core/utility/StateManager";
import {IApiResponseDto} from "../../../core/dto/common/ApiResponseDto";
import {ReportApiService} from "../../../core/api/report/ReportApiService";
import {IUpdateReportRequest} from "../../../core/api/report/request/UpdateReportRequest";
import {CoreConstant} from "../../../core/utility/CoreConstant";

interface IProps {
    id: string;
    onSuccessRequest(): void;
    onCancelForm(): void;
}

interface IState {
    data: IReadReportResponse;
    coreState: ICoreState;
    confirmationDialog: JSX.Element;
}

export class DetailReport extends React.Component<IProps, IState> {

    private readonly apiService = new ReportApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            data: {
                address: '',
                description: '',
                identityNumber: '',
                image: undefined,
                name: '',
                phone: '',
                title: '',
                reportDate: '',
                category: '',
                shortDescription: '',
                month: '',
                date: '',
                slug: '',
                isPublic: false,
                status: '',
                statusDescription: ''

            },
            coreState,
            confirmationDialog: <div/>
        }
    }

    public componentDidMount = () => {
        UtilityManager.scrollToEl('report-detail');
        this.readData();
    };

    public render() {

        return (
            <div id="report-detail">
                <Card fluid={true}>
                    <Card.Content>
                        <Card.Header>Detail Informasi</Card.Header>
                    </Card.Content>
                    <Card.Content>
                        {this.state.coreState.isLoading && this.state.coreState.loadingNotification}
                        {this.state.confirmationDialog}
                        <Grid verticalAlign='middle'>
                            <Grid.Row>
                                <Grid.Column width={4} />
                                <Grid.Column width={9}>
                                    {this.state.coreState.errorNotification}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                        <Form size='large' loading={this.state.coreState.isLoading}>
                            <Grid verticalAlign='middle'>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Tanggal Laporan</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Input
                                            name="reportDate" id="reportDate"
                                            value={this.state.data.reportDate}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Warga</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Input
                                            name="name" id="name"
                                            value={this.state.data.name}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>No KTP</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Input
                                            name="identityNumber" id="identityNumber"
                                            value={this.state.data.identityNumber}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Alamat</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Input
                                            name="address" id="address"
                                            value={this.state.data.address}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>No. Telp</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Input
                                            name="phone" id="phone"
                                            value={this.state.data.phone}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Judul Laporan</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Input
                                            name="title" id="title"
                                            value={this.state.data.title}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Deskripsi</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <TextArea
                                            rows={'10'}
                                            name="description" id="description"
                                            value={this.state.data.description}
                                            fluid={true} />
                                    </Grid.Column>
                                </Grid.Row>

                            </Grid>

                            <Grid verticalAlign='middle'>
                                <Grid.Row>
                                    <Grid.Column width={4}>
                                        <label style={{ float: 'right' }}>Gambar</label>
                                    </Grid.Column>
                                    <Grid.Column width={9}>
                                        <Image src={this.state.data.image} size='small' />
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Column floated='right' width={12}>
                                    <Dropdown text='Ubah Status' icon='caret down' floating={true} labeled={true} button={true} className='icon'>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => this.changeStatus(CoreConstant.ReportStatus.OnProcced)}>Sedang Diproses</Dropdown.Item>
                                            <Dropdown.Item onClick={() => this.changeStatus(CoreConstant.ReportStatus.Done)}>Sudah Selesai</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    {this.state.data.isPublic
                                        ? <Button type='button' onClick={this.setUnPublic}>Hilangkan di Web Utama</Button>
                                        : <Button type='button' onClick={this.setIsPublic}>Tampilkan di Web Utama</Button>}

                                    <Button type='button' onClick={this.props.onCancelForm}>Batal</Button>
                                </Grid.Column>
                            </Grid>

                        </Form>
                    </Card.Content>
                </Card>

            </div>
        );
    }

    private readData = () => {

        this.setState({
            coreState: StateManager.setOnLoading(this.state.coreState)
        });

        this.apiService.read(this.props.id)
            .then((data: IApiResponseDto) => {

                this.setState({
                    coreState: StateManager.setOffLoading(this.state.coreState),
                    data: data.result
                });

            }).catch((error: IApiResponseDto) => {
            this.setState({
                coreState: StateManager.showErrorNotification(this.state.coreState, error.errorMessage)
            });

        });

    };

    private setUnPublic = () =>{

        const request: IUpdateReportRequest = {
            status: this.state.data.status,
            isPublic: false
        };

        this.setState({
            coreState: StateManager.setOnLoading(this.state.coreState)
        });

        this.apiService.update(this.props.id, request)
            .then((data: IApiResponseDto) => {

                this.setState({
                    coreState: StateManager.setOffLoading(this.state.coreState)
                });

                this.props.onSuccessRequest();

            }).catch((error: IApiResponseDto) => {
            this.setState({
                coreState: StateManager.showErrorNotification(this.state.coreState, error.errorMessage)
            });

        });

    };

    private setIsPublic = () =>{

        const request: IUpdateReportRequest = {
            status: this.state.data.status,
            isPublic: true
        };

        this.setState({
            coreState: StateManager.setOnLoading(this.state.coreState)
        });

        this.apiService.update(this.props.id, request)
            .then((data: IApiResponseDto) => {

                this.setState({
                    coreState: StateManager.setOffLoading(this.state.coreState)
                });

                this.props.onSuccessRequest();

            }).catch((error: IApiResponseDto) => {
            this.setState({
                coreState: StateManager.showErrorNotification(this.state.coreState, error.errorMessage)
            });

        });

    };

    private changeStatus = (status: string) =>{

        const request: IUpdateReportRequest = {
            status,
            isPublic: this.state.data.isPublic
        };

        this.setState({
            coreState: StateManager.setOnLoading(this.state.coreState)
        });

        this.apiService.update(this.props.id, request)
            .then((data: IApiResponseDto) => {

                this.setState({
                    coreState: StateManager.setOffLoading(this.state.coreState)
                });

                this.props.onSuccessRequest();

            }).catch((error: IApiResponseDto) => {
            this.setState({
                coreState: StateManager.showErrorNotification(this.state.coreState, error.errorMessage)
            });

        });

    }

}


// WEBPACK FOOTER //
// ./src/component/admin/report/DetailReport.tsx